import { render, staticRenderFns } from "./DataTableUsers.vue?vue&type=template&id=0569cba8"
import script from "./DataTableUsers.vue?vue&type=script&lang=js"
export * from "./DataTableUsers.vue?vue&type=script&lang=js"
import style0 from "./DataTableUsers.vue?vue&type=style&index=0&id=0569cba8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports